import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileService } from 'src/app/___LOGIC/__files/file.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {


  @Input() pickerLabel;
  @Input() fileId;
  @Input() formatsAccepted;
  @Output() public selectedFile = new EventEmitter();
  
  clientId: string = 'client1';  // This would typically come from your authentication or user context
  folder: string = 'profile';  // Default folder (can be 'profile', 'personal', or 'processes')
  uploadProgress: boolean = false;
  selectedFiles: File[] = [];
  fileName: string;
  @ViewChild('fileInput') fileInputRef: ElementRef;

  ngOnInit(): void {}

  constructor(private fileService: FileService) { }

  handleFileSelection(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.selectedFile.emit({ fileId: this.fileId, file });
    }
  }

  isFileSelected(){
    return this.fileName && this.fileName.length>0;
  }

  private uploadFiles() {
    this.uploadProgress = true;
    this.selectedFiles.forEach(file => {
      this.fileService.uploadFile(this.clientId, this.folder, file).subscribe(response => {
        console.log('File uploaded successfully', response);
        this.uploadProgress = false;
        // Optionally, you can notify the parent component or reload the file list
      }, error => {
        console.error('File upload failed', error);
        this.uploadProgress = false;
      });
    });
  }

}